import { Component, OnInit, ViewChild } from '@angular/core';
import { BankDetail } from 'src/app/shared/models/clients/bankDetail';
import { SearchParams } from 'src/app/shared/models/searchParams';
import { BankDetailsModalComponent } from '../bank-details-modal/bank-details-modal.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { ToastrService } from 'ngx-toastr';
import { PrintService } from 'src/app/core/services/print.service';



@Component({
  selector: 'app-client-bank-details',
  templateUrl: './client-bank-details.component.html',
  styleUrls: ['./client-bank-details.component.scss']
})
export class ClientBankDetailsComponent implements OnInit {
  public bankAccounts: BankDetail[] = [];
  public clientId = null;
  public searchParams = new SearchParams();
  @ViewChild('bankModal') bankModal: BankDetailsModalComponent;

  constructor(
    private apiService: ClientsApiService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private printService: PrintService,
  ) {
    this.route.parent.data.subscribe(resolversData => {
      this.clientId = resolversData.client.id;
    });
  }

  ngOnInit(): void {
    this.loadBankAccounts();
  }

  loadBankAccounts() {
    this.spinner.show();
    this.apiService.getClientBanks(this.searchParams, this.clientId).subscribe(
      c => {
        this.spinner.hide();
        this.bankAccounts = c.results;
      }
    )
  }

  onSearch(e: KeyboardEvent) {
    if (e.keyCode === 13) {
      this.searchParams.page = 1;
      this.searchParams.search = (e.target as HTMLInputElement).value;
      this.loadBankAccounts();
    }
  }

  addNewBank() {
    const bankAccount = new BankDetail();
    bankAccount.clientId = this.clientId;
    this.bankModal.open(bankAccount);
  }

  editBank(bankAccount: BankDetail) {
    this.bankModal.open(bankAccount);
  }

  bankSubmit(bankAccount: BankDetail) {
    let action = '';
    if (this.bankAccounts.find(n => bankAccount.id === n.id)) {
      const i = this.bankAccounts.findIndex((value, index, array) => { return value.id === bankAccount.id });
      this.bankAccounts[i] = bankAccount;
      action = 'updated';
    } else {
      this.bankAccounts.push(bankAccount);
      action = 'created';
    }
    this.bankModal.close();
    this.toastr.success(`The Bank ${action}`, 'Success!');
  }


  print() {
    this.route.parent.data.subscribe(resolversData => {
      this.printService.data = { bankAccounts: this.bankAccounts, clientName: resolversData.client.fullName };
      this.printService.printDocument('client-bank');
    });
  }
}

